import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthShowcaseAsideComponent } from '@features/auth/presentation/components/auth-showcase-aside/auth-showcase-aside.component';

@Component({
  selector: 'app-auth-welcome',
  imports: [RouterModule, TranslateModule, AuthShowcaseAsideComponent],
  templateUrl: './auth-welcome.component.html',
})
export class AuthWelcomeComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  sessionExpired = false;

  ngOnInit(): void {
    this.sessionExpired =
      this.route.snapshot.queryParamMap.get('reason') === 'session-expired';
  }
}
